var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-img',{staticClass:"mb-3",attrs:{"src":"images/bild.png","fluid":""}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('presentation.tender'))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }